<template>
  <div>
    <v-data-table
      :headers="COMPUTED_HEADERS"
      :items="desserts"
      :items-per-page="-1"
      :search="pesquisar"
      item-key="nome_categoria"
      single-expand
      fixed-header
      show-expand
      :loading="loading"
      :height="altura_tabela"
      class="table-full-screen font-resp-tabela"
      @item-expanded="buscarProdutosCapaLista"
    >
      <template #progress>
        <v-progress-linear
          indeterminate
          rounded
          color="red"
          height="3"
        ></v-progress-linear>
      </template>

      <template v-slot:expanded-item="{ headers }">
        <td class="pa-0 ma-0" :colspan="headers.length">
          <TabelaDadosExpanded
            :itens_expandidos="itens_expandidos"
          />
        </td>
      </template>

      <template #top>
        <v-toolbar flat color="white">
          <v-icon size="20">mdi-format-list-checkbox</v-icon>
          <span class="font-weight-medium font-17 ml-2">Listas de preços</span>
          <v-spacer />

          <v-text-field
            v-model="pesquisar"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
            class="mr-7"
            style="max-width: 450px"
          ></v-text-field>

          <NovaLista @atualizar-listas-compra="buscarDados()" />
        </v-toolbar>
      </template>

      <template #item.acoes="{ item }">
        <SysMenu
          :close_on_click="true"
          :icone_personalizado="'$CashSync'"
          texto_titulo="Confirmação"
          :min_width="300"
          :max_width="500"
          texto_botao_aceitar="Confirmar"
          @confirmar-menu="editarPreco(item)"
        >
          <div class="text-justify mb-3">
            <p class="ma-0">
              Ao vincular uma lista de preço ao pedido de compra o sistema
              irá considerar como preço do produto o valor que consta na lista.
            </p>
            <p class="ma-0 mt-2">
              Além disso, marcando a opção abaixo é possivel atualizar o preço no cadastro do produto,
              dessa forma o valor de preço que consta na lista e no sistema serão o mesmo.
            </p>
          </div>

          <v-switch v-model="item.atualizar_preco_base_dados" hide-details dense>
            <template #label>
              <span class="pl-2 font-14">Atualizar o preço no cadastro do produto?</span>
            </template>
          </v-switch>
        </SysMenu>

        <DeletarLista
          icone_personalizado="mdi-delete"
          texto_titulo="Exclusão da lista de preço"
          texto_botao_aceitar="confirmar"
          :max_width="500"
          @confirmar-menu="deletarLista(item)"
          :desativar_remocao="item.esta_vinculada"
        >
          {{ `Deseja realmente excluir a lista de preço?` }}
        </DeletarLista>
      </template>
    </v-data-table>

    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      tile
      color="red accent-2"
    >
      <v-icon small>mdi-alert</v-icon>
      {{ message_delete }}

      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import {
  buscarListasDePreco,
  buscarProdutosListasDePreco,
  editarProdutosListasDePrecoNoCarrinho,
  deletarListasDePreco
} from "@/api/Fornecedor/ListasDePreco/index.js";
import NovaLista from "./NovaLista.vue";
import TabelaDadosExpanded from "./TabelaDadosExpanded.vue";
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import SysMenu from '@/components/utils/SysMenu.vue';
import DeletarLista from "./DeletarLista.vue";

export default {
  props: {
    "ativar-acoes": {
      type: Boolean,
      default: false
    },
    pedido_selecionado: {
      type: Object,
      default: () => ({})
    },
    id_fornecedor: {
      type: [String, Number],
      default: ''
    },
    id_grupo: {
      type: [String, Number],
      default: ''
    },
    altura_tabela: {
      type: String,
      default: 'calc(100vh - 232px)'
    }
  },
  components: { NovaLista, TabelaDadosExpanded, SysDialog, SysMenu, DeletarLista },
  data() {
    return {
      headers: [
        { text: "Lista", value: "id", width: "90" },
        { text: "Grupo", value: "info_grupo", width: "150" },
        { text: "Fornecedor", value: "razao_social", width: "" },
        { text: "Qtde. Produtos", value: "qtde_produtos", width: "140" },
        { text: "Data Importação", value: "data_importacao_formatada", width: "150" },
        { text: "Data Validade", value: "data_validade", width: "140" },
        { text: "Ações", value: "acoes", width: "80px" }
      ],
      desserts: [],
      old_desserts: [],
      pesquisar: "",
      loading: false,
      itens_expandidos: [],
      snackbar: false,
      message_delete: '',
      timeout: 2000,
    };
  },
  computed: {
    COMPUTED_HEADERS() {
      return this.headers;
    }
  },
  created() {
    this.buscarDados();
  },
  watch: {
    pedido_selecionado() {
      this.buscarDados();
    }
  },
  methods: {
    editarPreco(item) {
      const parametros = {
        id_capa: item.id,
        id_pedido: this.pedido_selecionado ? this.pedido_selecionado.idpedido : '',
        atualizar_preco_base_dados: item.atualizar_preco_base_dados
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        editarProdutosListasDePrecoNoCarrinho(parametros)
          .then(() => {
            this.$emit('atualizar-carrinho');
          })
      );
    },
    buscarDados() {
      const parametros = {
        id_grupo: this.id_grupo,
        id_fornecedor: this.pedido_selecionado.idfornecedor,
        grupo_analise: this.pedido_selecionado.grupo_analise_fornecedor,
        validar_vencimento: this.$route.path == '/compra'
      }
      this.$store.dispatch("loading/addRequisicao", buscarListasDePreco(parametros).then(listas => this.desserts = listas));
    },
    buscarProdutosCapaLista(event) {
      if (event.value) {
        this.old_desserts = this.desserts;
        this.desserts = [event.item];

        const parametros = { id_capa: event.item.id };
        this.$store.dispatch("loading/addRequisicao", buscarProdutosListasDePreco(parametros).then(dados => this.itens_expandidos = dados));
      } else {
        this.desserts = this.old_desserts;
      }
    },
    deletarLista(item) {
      this.$store.dispatch(
        "loading/addRequisicao",
        deletarListasDePreco(item.id)
          .then((msg) => {
            this.buscarDados();

            if (msg) {
              this.message_delete = msg;
              this.snackbar = true;
            }
          })
      );
    }
  },
}
</script>
